export default __webpack_public_path__ + "static/brcc-work-image-mobile-6cf435ff4c0332184b2fc78923de5ca4.webp";